/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { Select } from '../Select/Select'
import { getCrTeamTaskStepLabels } from '../../services/api/api.settings'
import { transformToSelectOptions, SelectOption } from '../../utils/selectOptions'
import { useTranslation } from 'react-i18next'

export interface SelectStepLabelValue {
  id: number
  text?: string
}

export interface SelectStepLabelProps {
  value?: SelectStepLabelValue | null
  name: string
  onChange: (value: SelectOption | null) => void
}

/**
 * SelectStepLabel - Component for selecting CR team task step labels
 *
 * Migrated from legacy lego/page/browser/request-change/SelectStepLabel.jsx
 * Uses modern React patterns with hooks and TypeScript
 */
export function SelectStepLabel(props: SelectStepLabelProps): React.ReactElement {
  const [value, setValue] = useState<number | null>(null)
  const [crStepLabels, setCrStepLabels] = useState<SelectOption[]>([])
  const { t } = useTranslation()

  // Sync internal value with props.value when options are loaded
  useEffect(() => {
    if (props.value !== null && props.value?.id !== value && crStepLabels.length) {
      if (props.value && props.value.id) {
        const initialValue = _.find(crStepLabels, { value: props.value.id })

        if (initialValue) {
          setValue(initialValue.value)
        }
      }
    }
  }, [props.value, crStepLabels])

  // Load CR team task step labels on mount
  useEffect(() => {
    // Get current language from i18next or default to empty string
    const lang = ''

    getCrTeamTaskStepLabels(lang).then((data: any) => {
      const options = transformToSelectOptions(data.elements, 'id', 'text')
      setCrStepLabels(options)
    })
  }, [])

  return (
    <Select
      name={props.name}
      value={value}
      options={crStepLabels}
      placeholder={t('SELECT_CR_TASK_LABEL_PLACEHOLDER')}
      onChange={(option: any) => props.onChange(option)}
      showNewOptionAtTop={true}
      id="85a3a33b-bdaf-44a0-9a83-2352084d39e9"
    />
  )
}
